import React from 'react'
import { supabase } from './SupabaseClient'

const STATUS = ["オフライン", "オンライン", "造形中"]

type PrinterData = {
    id: string;
    created_at: string;
    permission: number;
    printer_name: string;
    status: number;
    user_id: string;
}

type PrinterCardProps = {
    data: PrinterData;
    reload_data: any;
}

type GetPrinterStatusProps = {
    status:number;
}


const GetPrinterStatus: React.FC<GetPrinterStatusProps> = ({status})=>{
    switch (status) {
        case 0: {
            return (
                <div className="mb-4 flex">
                  <div className="rounded-full bg-red-500 w-4 h-4 self-center mx-2"></div>
                  {STATUS[status]}
                </div>
            )
        }
        case 1: {
            return (
                <div className="mb-4 flex">
                  <div className="rounded-full bg-green-500 w-4 h-4 self-center mx-2"></div>
                  {STATUS[status]}
                </div>
            )
        }
        case 2: {
            return (
                <div className="mb-4 flex">
                  <div className="rounded-full bg-blud-500 w-4 h-4 self-center mx-2"></div>
                  {STATUS[status]}
                </div>
            )
        }
        default: {
            return (
                <div></div>
            )
        }
    }
}



const PrinterCard: React.FC<PrinterCardProps> = ({data, reload_data}) => {
    const handleDeletePrinter = async () => {
        console.log("delete")
        console.log(data)
        const { error } = await supabase
          .from('printer')
          .delete()
          .eq('id', data.id)
        if(error !== null){
            alert(error)
        }

        await reload_data()
    }
    console.log(data)

    return (

      <div
          id="partnerCard"
          className="bg-white outline outline-offset-2 outline-gray-500/50 text-gray-500 overflow-hidden rounded-md max-w-sm p-2 min-h-80 flex flex-col"
      >
          <div>
              <h3 className="text-left pl-8 pb-4 pt-2 text-xl">
                  {data.printer_name}
              </h3>
          </div>

          <GetPrinterStatus status={data.status}></GetPrinterStatus>

          {

          //<div className="flex items-center justify-center bg-[#2a2a2a] min-h-[200px]">

          //        <a
          //            className="flex items-center justify-center"
          //            href="#"
          //            target="_blank"
          //            rel="noreferrer noopener"
          //        >
          //         <img
          //                src="https://res.cloudinary.com/easycode/image/upload/v1655738921/Logo/Logo_transparent_vbriwo.png"
          //                alt="EasyCode"
          //                className="w-1/2 object-cover"
          //            />

          //        </a>
          //</div>
          }

          <div className="mt-auto grid grid-cols-6 gap-y-2">
              <button className="col-start-1 col-span-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">編集</button>
              <button className="col-start-5 col-span-2 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full" onClick={handleDeletePrinter}>削除</button>
              <button className="col-start-1 col-span-6 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full">キューを確認</button>
          </div>
      </div>

    )

}

export default PrinterCard